<template>
    <!-- 项目考核表 -->
    <div>
        <!-- <div style="font-size:20px;float:left;margin:40px;font-weight:600">项目考核表</div> -->
        <div style="height:750px;background-color:white;margin:5px 5px 20px 5px;padding-bottom: 20px;">
            <!-- 查询框 -->
            <div style="margin-left:3%">
                <el-row style=" padding: 20px 0;">
                    <el-col :span="18">
                        <div style="display:inline-block">
                            <span>组织架构</span>
                            <el-cascader v-model="condition.organizeIds_num" clearable collapse-tags
                                :props="props"></el-cascader>
                            <span>一级分类</span>
                            <el-select v-model="condition.first_id" placeholder="请选择" @change="secondDict" clearable>
                                <el-option v-for="item in firstList" :key="item.id" :label="item.first_category"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                            <span>二级分类</span>
                            <el-select v-model="condition.secondary_id" placeholder="请选择" clearable>
                                <el-option v-for="item in secondList" :key="item.id" :label="item.secondary_category"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                            <span>时间</span>
                            <el-date-picker v-model="condition.annual" type="year" placeholder="请选择" :clearable="false"
                                value-format="yyyy">
                            </el-date-picker>
                        </div>
                    </el-col>
                    <el-col :span="3">
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="query">
                            查询</el-button>
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                            导出</el-button>
                        <!-- <download-excel class="export-excel-wrapper" :fields="download_excel" name="大排名报表"
                            :fetch="ExportForm" style="top:100px;width:5%">
                        </download-excel> -->
                    </el-col>
                </el-row>
            </div>
            <!-- 表格 -->
            <div style="margin:0 3%;margin-top:5px">
                <el-row>
                    <el-table ref="mytable" :header-cell-style="{ background: '#d3eae2', color: '#000000' }" height="574px"
                        :row-class-name="tableRowClassName" :data="tableData" tooltip-effect="dark" style="width: 100%"
                        @selection-change="handleSelectionChange">
                        <template>
                            <el-table-column align="center" label="序号">
                                <el-table-column align="center" label="一级序号">
                                    <template slot-scope="scope_1">
                                        {{ scope_1.$index + 1 }}
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="科目等级">
                                <el-table-column prop="first_name" align="center" label="一级科目">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="科目明细">
                                <el-table-column prop="secondary_name" align="center" label="二级科目">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="年度预算A">
                                <el-table-column prop="annualBudgetA" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="年度预算B">
                                <el-table-column prop="annualBudgetB" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="年度预算C">
                                <el-table-column prop="annualBudgetExecuteC" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="预算偏差率AB">
                                <el-table-column prop="budgetDeviationAB" align="center" label="月度修正与年初预算(AB版)偏差率">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="执行偏差率AC">
                                <el-table-column prop="executionDeviationAC" align="center" label="实际执行与年初预算(AC版)偏差率">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="执行偏差率BC">
                                <el-table-column prop="executionDeviationBC" align="center" label="实际执行与月度修正(BC版)偏差率">

                                </el-table-column>
                            </el-table-column>
                        </template>
                        <template>
                            <el-table-column align="center" label="1月">
                                <el-table-column prop="budgetBeginning1" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="1月">
                                <el-table-column prop="monthlyCorrection1" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="1月">
                                <el-table-column prop="practical1" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="2月">
                                <el-table-column prop="budgetBeginning2" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="2月">
                                <el-table-column prop="monthlyCorrection2" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="2月">
                                <el-table-column prop="practical2" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="3月">
                                <el-table-column prop="budgetBeginning3" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="3月">
                                <el-table-column prop="monthlyCorrection3" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="3月">
                                <el-table-column prop="practical3" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="4月">
                                <el-table-column prop="budgetBeginning4" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="4月">
                                <el-table-column prop="monthlyCorrection4" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="4月">
                                <el-table-column prop="practical4" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="5月">
                                <el-table-column prop="budgetBeginning5" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="5月">
                                <el-table-column prop="monthlyCorrection5" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="5月">
                                <el-table-column prop="practical5" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="6月">
                                <el-table-column prop="budgetBeginning6" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="6月">
                                <el-table-column prop="monthlyCorrection6" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="6月">
                                <el-table-column prop="practical6" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                        </template>
                        <el-table-column align="center" label="上半年合计">
                            <el-table-column prop="budgetBeginningHalf" align="center" label="上半年预算(A版)">

                            </el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="上半年合计">
                            <el-table-column prop="monthlyCorrectionHalf" align="center" label="上半年修正(B版)">

                            </el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="上半年合计">
                            <el-table-column prop="practicalHalf" align="center" label="上半年执行(C版)">

                            </el-table-column>
                        </el-table-column>
                        <template>
                            <el-table-column align="center" label="7月">
                                <el-table-column prop="budgetBeginning7" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="7月">
                                <el-table-column prop="monthlyCorrection7" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="7月">
                                <el-table-column prop="practical7" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="8月">
                                <el-table-column prop="budgetBeginning8" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="8月">
                                <el-table-column prop="monthlyCorrection8" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="8月">
                                <el-table-column prop="practical8" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="9月">
                                <el-table-column prop="budgetBeginning9" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="9月">
                                <el-table-column prop="monthlyCorrection9" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="9月">
                                <el-table-column prop="practical9" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="10月">
                                <el-table-column prop="budgetBeginning10" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="10月">
                                <el-table-column prop="monthlyCorrection10" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="10月">
                                <el-table-column prop="practical10" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="11月">
                                <el-table-column prop="budgetBeginning11" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="11月">
                                <el-table-column prop="monthlyCorrection11" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="11月">
                                <el-table-column prop="practical11" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="12月">
                                <el-table-column prop="budgetBeginning12" align="center" label="年初预算(A版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="12月">
                                <el-table-column prop="monthlyCorrection12" align="center" label="月度修正(B版)">

                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="12月">
                                <el-table-column prop="practical12" align="center" label="实际执行(C版)">

                                </el-table-column>
                            </el-table-column>
                        </template>
                        <el-table-column align="center" label="下半年合计">
                            <el-table-column prop="budgetBeginningSecond" align="center" label="下半年预算(A版)">

                            </el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="下半年合计">
                            <el-table-column prop="monthlyCorrectionSecond" align="center" label="下半年修正(B版)">

                            </el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="下半年合计">
                            <el-table-column prop="practicalSecond" align="center" label="下半年执行(C版)">

                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row style="margin-top: 10px; text-align: center;">
                    <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                        layout=" prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    data() {
        var organizeFind = async (e, spare8) => {
            var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
                identification: "1",
                organize_id: e,
                spare8: spare8,
            });
            return organizeList.data;
        };
        return {
            //列表相关
            page_num: 1,
            page_size: 10,
            total: 0,
            tableData: [],
            //复选框ids
            ids: [],

            //页面相关
            dialogVisible: false,
            //组织架构数据
            organizeList: [],
            condition: {
                organizeIds_num: [],
                annual: '',
                first_id: '',
                secondary_id: '',
            },
            //级联下拉配置
            props: {
                lazy: true,
                async lazyLoad(node, resolve) {
                    if (node.level === 0) {
                        return resolve(await organizeFind('', 'group'));
                    } else {
                        resolve(await organizeFind(node.data.id, ''));
                    }
                },
                value: "id",
                label: "organize_name",
                children: "organizeList",
                checkStrictly: true,
                multiple: false,
            },

            download_excel: {
                "专业性": "organize_id_one_name",
                "子公司": "organize_id_two_name",
                "事业部": "organize_id_three_name",
                "项目名称": "project_name",
                "总监": "project_inspector_general",
                "项目负责人": "project_leader",
                "核定标准 - 合同收入": "contract_revenue",
                "核定标准 - 工资定额": "wage_quota",
                "核定标准 - 定额工资占比": "proportion_fixed_salary",
                "核定标准 - 物料定额": "material_quota",
                "本月 - 实际收入": "material_quota",
                "本月 - 工资 - 应发工资": "wages_payable",
                "本月 - 工资 - 临勤工资": "temporary_wages",
                "本月 - 工资 - 支援工资": "support_salary",
                "本月 - 物料 - 实际物料": "material_quota",
                "本月 - 物料 - 临采物料": "material_quota",
                "上月 - 定额确认 - 工资定额": "absence_days",
                "上月 - 定额确认 - 物料定额": "absence_days",
            },
            firstList: [],
            secondList: [],
        }
    },
    mounted() {
        if (this.$refs.mytable.doLayout) {
            this.$refs.mytable.doLayout()
        }
        this.firstDict()
    },
    methods: {
        //分页
        handleCurrentChange(val) {
            this.page_num = val; 
            this.query();
        },
        async firstDict() {
            var firstList = await this.$globals.AxiosGet("budgetFirst/getList", {});
            this.firstList = firstList.data
        },
        async secondDict(e) {
            var secondList = await this.$globals.AxiosGet("BudgetSecondary/getList?info=" + e, {});
            this.secondList = secondList.data
        },

        async query() {
            var url = "budgetForm/budgetFormReport";
            var record = {
                organizeIds_num: [],
                first_id: '',
                secondary_id: '',
                annual: '',
            };
            var data = await this.$globals.AxiosPost(url, this.condition);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableData = data;
                    this.total = data.total;
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },

        //导表
        async ExportForm() {

            var url = "reportProjectAssessment/selectReportProjectAssessment";
            var record = {
                years_date: this.condition.years_date + '-01'
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableDatas = data.list;
                    this.total = data.total;
                    if (this.tableDatas.length > 0) {
                        this.$message.success("导表成功！文件下载中！");
                        return this.tableDatas;
                    } else {
                        this.$message.success("没有可以导出的数据！");
                        return null;
                    }
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        //初始化组织架构及下面的人
        async organizeFind() {
            var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                identification: "1",
            });
            this.organizeList = this.getTreeData(organizeList.data);

        },
        getTreeData(data) {
            // 循环遍历json数据
            for (var i = 0; i < data.length; i++) {

                if (data[i].organizeList.length < 1) {
                    // children若为空数组，则将children设为undefined
                    data[i].organizeList = undefined;
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].organizeList);
                }
            }
            return data;
        }
    },
    created() {
        this.Find();
        this.organizeFind();
    }
}
</script>

<style scoped="scoped">
.el-button--goon:focus,
.el-button--goon:hover {
    background: #006E4B;
    color: #fff;
}

.el-button--goon {
    color: #FFF;
    background-color: #006E4B;
    width: 85px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// budget_comparison_table.vue?2e95daf0